import {
  ICartSharedContentsItem,
  AuthContextWithOrder,
} from '@monofront/types';
import { IAuthState } from '../contexts';

export const createUseMerchRecommendationsContents = (
  useAuthentication: () => Partial<IAuthState>,
) => {
  return (
    cartSharedContentsItems: ICartSharedContentsItem[] | undefined,
  ): ICartSharedContentsItem | undefined => {
    const { isAuthenticated, isMember, customer } = useAuthentication();
    const orderCount = customer?.orderCount || 0;

    if (!cartSharedContentsItems?.length) {
      console.warn(`No merch recommendation content found`);

      return undefined;
    }

    if (!isAuthenticated) {
      return cartSharedContentsItems.find(
        ({ authContext }) => authContext === AuthContextWithOrder.ANONYMOUS,
      );
    }
    if (!isMember && !orderCount) {
      return cartSharedContentsItems.find(
        ({ authContext }) =>
          authContext === AuthContextWithOrder.CONNECTED_BUT_NOT_MEMBER,
      );
    }
    if (isMember && !orderCount) {
      return cartSharedContentsItems.find(
        ({ authContext }) =>
          authContext ===
          AuthContextWithOrder.CONNECTED_AND_MEMBER_WITH_NO_ORDER,
      );
    }
    if (isMember && orderCount) {
      return cartSharedContentsItems.find(
        ({ authContext }) =>
          authContext === AuthContextWithOrder.CONNECTED_AND_MEMBER_WITH_ORDERS,
      );
    }
    if (!isMember && orderCount) {
      return cartSharedContentsItems.find(
        ({ authContext }) =>
          authContext ===
          AuthContextWithOrder.CONNECTED_AND_NOT_MEMBER_WITH_ORDERS,
      );
    }

    return cartSharedContentsItems[0];
  };
};
